<div class="tour-page-content-container">
  <div class="tour-container">
    <employee-tour
      *ngFor="let placer of placers"
      [placer]="placer"
      [allPlacers]="placers"
    ></employee-tour>
  </div>
</div>
